import {MenuItem, Stack} from "@mui/material";
import {useState} from "react";
import ErrorHandlingForm from "../../../../components/formValidation/ErrorHandlingForm";
import CustomSelect from "../../../../components/formValidation/CustomSelect";
import useCategoryQueries from "../../../../hooks/queries/useCategoryQueries";


const Category = ({reference, data, setData}) => {
    const {categoryBusinessQuery} = useCategoryQueries()
    const {data: categories, isPending: categoriesLoading} = categoryBusinessQuery

    const [errors, setErrors] = useState({
        category: false,
    });

    const validators = {
        category: [],
    }


    return <ErrorHandlingForm data={data} setData={setData} errors={errors} setErrors={setErrors} validators={validators} reference={reference}>
        <Stack spacing={1} marginTop={2} marginBottom={2}>
            <CustomSelect
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                variant='standard'
                name='category'>
                {categories?.map((c, i) => <MenuItem key={`category_${i}`} value={c?.id}>{c?.name}</MenuItem>)}
            </CustomSelect>
        </Stack>
    </ErrorHandlingForm>
}

export default Category